export default {
  methods: {
    drag(event) {
      this.$store.commit('interfaceStore/startDrag', {
        event: event,
        draggableClasses: this.draggableClasses,
        droppableClasses: this.droppableClasses,
        isControlPanelElement: true,
        targetRoot: this.targetRoot,
        currentArea: this.dragArea,
        onDrop: this.onDrop,
      });
    }
  }
};